import {
  COOKIES_STORAGE_KEY as COOKIES_STORAGE_KEY_V2,
  COOKIES_EXPIRE_STORAGE_KEY as COOKIES_EXPIRE_KEY_V2,
  LEGACY_COOKIES_STORAGE_KEY,
  LEGACY_COOKIES_EXPIRE_STORAGE_KEY,
} from './storageKeys'

const COOKIE_VERSION_KEY = 'cookie_version'
const COOKIE_VERSION_VALUE = '2'
const NEW_VERSION_KEY = 'cookies_version_flag'

const getStorage = (): Storage | null => {
  try {
    if (typeof window !== 'undefined' && 'localStorage' in window) {
      return window.localStorage
    }
  } catch (e) {}
  return null
}

export const markCookiesVersion = () => {
  const storage = getStorage()
  if (!storage) {
    return
  }
  try {
    storage.setItem(NEW_VERSION_KEY, COOKIE_VERSION_VALUE)
    storage.setItem(COOKIE_VERSION_KEY, COOKIE_VERSION_VALUE)
  } catch (e) {}
}

export const ensureCookiesVersion = (): boolean => {
  const storage = getStorage()
  if (!storage) {
    return false
  }

  try {
    const current = storage.getItem(COOKIE_VERSION_KEY)
    const newCurrent = storage.getItem(NEW_VERSION_KEY)
    const hasNewVersion = newCurrent === COOKIE_VERSION_VALUE
    const hasLegacyVersion = current === COOKIE_VERSION_VALUE

    if (hasNewVersion) {
      return true
    }

    if (hasLegacyVersion) {
      try { storage.removeItem(LEGACY_COOKIES_STORAGE_KEY) } catch (e) {}
      try { storage.removeItem(LEGACY_COOKIES_EXPIRE_STORAGE_KEY) } catch (e) {}
      try { storage.removeItem(COOKIE_VERSION_KEY) } catch (e) {}
      return false
    }
  } catch (e) {
    // ignore read issues and fall through to cleanup
  }

  try { storage.removeItem(COOKIES_STORAGE_KEY_V2) } catch (e) {}
  try { storage.removeItem(COOKIES_EXPIRE_KEY_V2) } catch (e) {}
  try { storage.removeItem(LEGACY_COOKIES_STORAGE_KEY) } catch (e) {}
  try { storage.removeItem(LEGACY_COOKIES_EXPIRE_STORAGE_KEY) } catch (e) {}
  try { storage.removeItem(NEW_VERSION_KEY) } catch (e) {}
  try { storage.removeItem(COOKIE_VERSION_KEY) } catch (e) {}

  return false
}
